import { Announcement } from "interfaces/content";
import actionCreatorFactory from "../actionCreatorFactory";

const actionCreator = actionCreatorFactory();

export const dismissAnnouncement = actionCreator<Announcement["id"]>("DISMISS_ANNOUNCEMENT");
